export default __webpack_public_path__ + "static/media/bnb_square_logo.2d1fd22f.svg";